// extracted by mini-css-extract-plugin
export default {"timePickerStyles":"timePickerStyles_IA3_T","textalignRight":"textalignRight_ElxhQ","textalignLeft":"textalignLeft_rZbM0","textalignCenter":"textalignCenter_tj1jQ"};